/* eslint-disable react-hooks/rules-of-hooks */
import { useMutation } from "@apollo/client";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { useEffect, useState } from "react";

import { Link } from "react-router-dom";
import { Table } from "../../../../../../components/Functional";
import Toggle from "../../../../../../components/ui/Input/components/Toggle";
import { EXHIBITED_OPTIONS } from "../../../../../../constants/exhibitedOptions";
import { UPDATE_EXHIBITION_WORK } from "../../../../../../graphql/mutation/ExhibitionWork";
import { FETCH_EXHIBITIONS_V2 as fetchExhibitionsV2 } from "../../../../../../graphql/query/Exhibition";
import { formatDate, formatTime } from "../../../../../../util";
import SectionHeader from "../../components/SectionHeader";

const InstanceArtfair = props => {
  const { instanceId } = props || {};
  const findExhibitionWork = works =>
    works?.find(work =>
      [work?.instance?.id, work?.instanceId].includes(props?.instanceId),
    );

  const tableProps = {
    variant: "dynamicHeight",
    dataKey: "exhibitionsV2",
    rowClassName: values => {
      const work = findExhibitionWork(values?.exhibitionWorks);

      return work?.removed
        ? "inset-0 bg-gray-300 opacity-20 hover:opacity-50"
        : "";
    },
    headers: [
      {
        label: <XMarkIcon className={`text-black-700 ml-1 h-5 w-5`} />,
        type: "custom",
        component: props => {
          const work = findExhibitionWork(props?.values?.exhibitionWorks);
          const [removed, setRemoved] = useState(work?.removed); // -1 = removed, 0 = going
          const [updateExhibitionWork] = useMutation(UPDATE_EXHIBITION_WORK());

          if (!work) return null;

          useEffect(() => {
            updateExhibitionWork({
              variables: {
                input: {
                  id: work.id,
                  removed,
                },
              },
            });
          }, [removed, updateExhibitionWork, work]);

          return (
            <Toggle
              designType="checkbox"
              onChange={setRemoved}
              value={removed}
            />
          );
        },
      },
      {
        label: "Art Fair",
        name: "title",
        type: "custom",
        widthInPx: 300,
        component: props => {
          return (
            <Link to={`/exhibition/${props?.id}/details`} className="underline">
              <h5>{props?.label}</h5>
            </Link>
          );
        },
      },
      { label: "Date", type: "label", name: "fullDate", widthInPx: 200 },
      {
        label: "Exhibited",
        type: "custom",
        component: props => {
          const work = findExhibitionWork(props?.values?.exhibitionWorks);
          if (!work) return null;

          const exhibitedAt = EXHIBITED_OPTIONS.find(
            option => option.value === work?.exhibited,
          );

          return <div className="max-w-[10rem]">{exhibitedAt?.label}</div>;
        },
      },
      {
        label: "Notes",
        type: "custom",
        component: props => {
          const work = findExhibitionWork(props?.values?.exhibitionWorks);
          const note = work?.notes;

          if (!work) return null;

          return (
            <div className="max-w-[30rem] truncate" title={note}>
              {note}
            </div>
          );
        },
      },
      {
        label: "Updated",
        type: "custom",
        component: props => {
          const work = findExhibitionWork(props?.values?.exhibitionWorks);

          if (!work) return null;

          return (
            <div
              className="max-w-[8rem]"
              title={`by ${work.user} @ ${formatTime(work.updatedAt)}`}
            >
              {formatDate(work.updatedAt)}
            </div>
          );
        },
      },
    ],
    inputs: [],
    FETCH_QUERY: fetchExhibitionsV2({
      exhibitionWorks: {},
    }),
    variables: {
      type: {
        operator: "eq",
        value: "Artfair",
      },
      _exhibitionWork: {
        _instance: {
          id: {
            operator: "eq",
            value: instanceId,
          },
        },
      },
    },
  };

  return (
    <div className="w-full">
      <SectionHeader title="Artfairs" />
      <div className="flex w-full">
        <div className="flex-1">
          <Table {...tableProps} />
        </div>
      </div>
    </div>
  );
};

export default InstanceArtfair;
